import { render, staticRenderFns } from "./EmailTemplate1.vue?vue&type=template&id=54e425e0"
import script from "./EmailTemplate1.vue?vue&type=script&lang=js"
export * from "./EmailTemplate1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports